<template>
  <div>
    <el-form label-position="left" label-width="150px">

      <el-divider content-position="left">申请人信息</el-divider>

      <el-form-item label="申请人" prop="">
        <el-input v-model="detail.userName" readonly></el-input>
      </el-form-item>

      <el-divider content-position="left">项目信息</el-divider>

      <el-form-item label="项目立项编号" prop="projectIden">
        <el-input v-model="detail.projectIden" readonly></el-input>
      </el-form-item>

      <el-form-item label="项目名称" prop="projectName">
        <el-input v-model="detail.projectName" readonly></el-input>
      </el-form-item>

      <el-form-item label="项目负责人" prop="managerName">
        <el-input v-model="detail.managerName" readonly></el-input>
      </el-form-item>

      <div v-if="role === 1">
        <el-form-item label="项目预计金额" prop="projectAmountExpect">
          <el-input v-model="detail.projectAmountExpect" maxlength="12" readonly>
          </el-input>
        </el-form-item>

        <div v-for="(item,index) in surveys " :key="index">
          <el-form-item label="项目状态" prop="surveyState">
            <el-radio-group v-model="item.surveyState" disabled>
              <el-radio label="1">已沟通</el-radio>
              <el-radio label="2" disabled>已采购</el-radio>
              <el-radio label="3" disabled>已签约</el-radio>
              <el-radio label="4" disabled>已回款</el-radio>
              <el-radio label="5" disabled>已实施</el-radio>
              <el-radio label="6" disabled>项目终止</el-radio>
              <el-radio label="7" disabled>已完成</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="项目概况" prop="surveyBody">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="item.surveyBody"
                      readonly></el-input>
          </el-form-item>
        </div>

        <el-divider content-position="left">渠道信息</el-divider>

        <el-form-item label="是否通过渠道联系" prop="isChannel">
          <el-radio-group v-model="detail.isChannel" disabled>
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="Number(detail.isChannel)===1" >
          <el-form-item label="渠道公司" prop="channelCompany">
            <el-input v-model="detail.channelCompany" readonly></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人" prop="channelUserName">
            <el-input v-model="detail.channelUserName" readonly></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人电话" prop="channelUserPhone">
            <el-input v-model="detail.channelUserPhone" readonly></el-input>
          </el-form-item>
        </div>

        <el-divider content-position="left">业主信息</el-divider>

        <el-form-item label="业主单位" prop="ownerCompany">
          <el-input v-model="detail.ownerCompany" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人" prop="ownerUserName">
          <el-input v-model="detail.ownerUserName" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人职位" prop="ownerUserPosition">
          <el-input v-model="detail.ownerUserPosition" readonly></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人电话" prop="ownerUserPhone">
          <el-input v-model="detail.ownerUserPhone" readonly></el-input>
        </el-form-item>

        <div v-if="contracts.length > 0">
          <el-divider content-position="left">合同信息</el-divider>
          <el-timeline v-for="(item, index) in contracts" :key="index">
            <el-timeline-item :timestamp="item.contractSignTime" placement="top">
              <div class="item-text">合同名字: {{item.contractName}}</div>
              <div class="item-text">合同类型: {{fileType[item.contractType-1]}}</div>
              <div v-if="item.contractAmount !== 0">
                <div class="item-text">合同金额: {{item.contractAmount}}</div>
                <div class="item-text">
                  <div style="margin-right: 6px">回款进度:</div>
                  <div style="width: 400px">
                    <el-progress :percentage="item.process" color="#409EFF"></el-progress>
                  </div>
                </div>
              </div>
              <el-link type="primary" @click="viewPdf(item.contractId)">查看详情</el-link>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

    </el-form>

    <el-dialog title="合同信息" v-if="showInfo" :append-to-body="true" :visible.sync="showInfo" top="6vh" width="1200px">
      <ContractDialog :contract-id="contractId"></ContractDialog>
    </el-dialog>

    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width:100%; height:100%;">
        <iframe id="myIframe" :src="pdfurl" width="100%" height="900px"></iframe>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import {requestProjectDetail} from "@/api";
import {minioServer, IsPdf} from "@/util";
import ContractDialog from "@/components/item/common/ContractDialog.vue";
export default {
  name: "ProjectDialog",
  components: {ContractDialog},
  props: {
     "projectId": "",
     "role": 0
  },
  data() {
    return {
      contractId: "",
      showInfo: false,
      detail: {},
      user: {},
      surveys: [],
      contracts: [],
      enforces: [],
      showPdf: false,
      pdfurl: "",
      fileType: ['销售合同','渠道合同', '框架协议']
    }
  },
  created() {
    this.getObject()
  },
  methods: {
    getObject() {
      requestProjectDetail({
        projectId: this.projectId,
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.detail.isChannel = this.detail.isChannel.toString()
            console.log(this.detail)
            this.surveys = res.object.surveys
            for (let i = 0; i < this.surveys.length; i++) {
              this.surveys[i].surveyState = this.surveys[i].surveyState.toString()
            }
            this.user = res.object.user
            this.contracts = res.object.contracts
            let data = res.object.contracts
            for (let i = 0; i < data.length; i++) {
              const item = data[i]
              const payback = item.payback
              let sum = 0
              for (let p of payback) {
                sum += p.contractAmount
              }
              if (item.contractAmount === 0) {
                data[i].process = 0
              } else {
                let process = Math.ceil((sum/item.contractAmount) * 100)
                data[i].process = process > 100 ? 100 : process
              }
            }
            this.contracts = data
            for (let i = 0; i < this.contracts.length; i++) {
              this.contracts[i].signCompany = JSON.parse(res.object.contracts[i].signCompany)
            }
            console.log(this.contracts)
            this.enforces = res.object.enforces
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    download(path) {
      window.open(minioServer + path)
    },
    viewPdf(path) {
      this.showInfo = true
      this.contractId = path
//      this.showPdf = true
//      this.pdfurl = "http://localhost:8080/pdfjs/web/viewer.html?file=" + minioServer + path
    },
    isPdf(fileName) {
      return IsPdf(fileName)
    }
  }
}
</script>

<style scoped>
.pdf-viewer {
  margin-bottom: 0;
}
.item-text {
  font-size: 16px;
  margin: 6px 0;
  display: flex;
}
</style>